import styled from 'styled-components';

export const CardErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  min-height: 120px;
`;

export const ErrorIcon = styled.div`
  width: 32px;
  height: 32px;
  margin-bottom: 12px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#ef4444' : '#dc2626')};

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const ErrorTitle = styled.div`
  font-size: 13px;
  font-weight: 300;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f8fafc' : '#1e293b')};
  margin-bottom: 4px;
  text-align: center;
`;

export const ErrorDescription = styled.div`
  font-size: 12px;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#64748b')};
  text-align: center;
  line-height: 1.4;
`;

export const RetryButton = styled.button`
  margin-top: 12px;
  padding: 6px 16px;
  background: transparent;
  border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e2e8f0')};
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => (theme.mode === 'dark' ? '#f8fafc' : '#1e293b')};
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#f1f5f9')};
    border-color: ${({ theme }) => (theme.mode === 'dark' ? '#4b5563' : '#cbd5e1')};
  }
`;
